<template>
    <div>
        <!-- v-permission="'Company:ExpirationTime'" -->
        <el-button v-permission="'Company:ExpirationTime'" size="small" @click="_onClick">到期时间</el-button>
        <el-dialog :title="row.T_expirationTime ? '修改' : '添加'" :visible.sync="dialogVisible" width="350px"
            append-to-body>
            <el-form ref="formRef" hide-required-asterisk label-position="top" :model="form" :rules="rules"
                label-width="100px">
                <el-form-item label="设置到期时间"> <!-- prop="T_expirationTime" -->
                    <el-date-picker v-model="form.T_expirationTime" type="date" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd" style="width: 100%;" placeholder="选择日期时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="_confirm">立 即 配 置</el-button>
                    <el-button type="default" @click="dialogVisible = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { contractExpires } from '@/api/companyManagement/Company.js'
export default {
    props: {
        row: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                T_expirationTime: null,
                Id: this.row.Id
            },
            rules: {
                T_expirationTime: [{ required: true, message: '请选择到期时间', trigger: 'blur' }]
            }
        };
    },
    methods: {
        _onClick() {
            this.form.T_expirationTime = this.row.T_expirationTime
            this.dialogVisible = true
            this._resetForm()
        },

        _confirm() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) { this._setDetails() }
            })
        },
        //详情列表Api
        async _setDetails() {
            contractExpires(this.form).then(res => {
                console.log('res', res);
                if (res && res.data.Code == 200) {
                    this.$message.success('设置成功')
                    this.dialogVisible = false
                    // this.$emit('update-row',this.form.T_expirationTime)
                    this.$emit('update:expirationTime', this.form.T_expirationTime)
                }
            })
        },
        _resetForm() {
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
        },
    },
};
</script>
